import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import { PagesClientSearchFiltersContent } from "./SearchFiltersContent";
import type { UseLocalStorageReducerDispatch } from "@dealer-center/core-components";
import { SlideOut } from "@dealer-center/core-components";

export interface PagesClientSearchFiltersSlideOutProps {
  pinFilters: boolean;
  setPinFilters: (pinFilters: boolean) => void;
  showFilters: boolean;
  setShowFilters: (showFilters: boolean) => void;
  dispatchAccountSearchFavorites: UseLocalStorageReducerDispatch<dealerSearchIncoming>;
  isDesktop: boolean;
}

export const PagesClientSearchFiltersSlideOut = ({
  showFilters,
  setShowFilters,
  dispatchAccountSearchFavorites,
  pinFilters,
  setPinFilters,
  isDesktop
}: PagesClientSearchFiltersSlideOutProps) => {
  return (
    <SlideOut
      hasBridgeBar
      position="left"
      show={showFilters}
      onHide={() => setShowFilters(false)}
    >
      <PagesClientSearchFiltersContent
        dispatchAccountSearchFavorites={dispatchAccountSearchFavorites}
        isDesktop={isDesktop}
        pinFilters={pinFilters}
        setPinFilters={setPinFilters}
      />
    </SlideOut>
  );
};
